












export default {
    name: 'single-avatar',
    props: {
        character: {},
        size: {
            type: String,
            default: 'default'
        },
        setName: {
            type: String,
            default: 'abstract-avatars'
        }
    }
};
